import { Api } from "./ingressRpcApi";

export let rootIngressApi = new Api();
